import { NavLink } from 'react-router-dom';

import { SideNavMultiLevel, SideNavSingleLevel } from '.';
import { hasChildren } from './nav.utils';
import { NestedMenuItem } from './useNestedMenu';

export type CustomMenuItemProps = {
  item: NestedMenuItem;
};

const CustomMenuItem: React.FC<CustomMenuItemProps> = ({ item }) => {
  const Component =
    hasChildren(item) ? SideNavMultiLevel : SideNavSingleLevel;

  return (
    <>
      {item?.to ? (
        <NavLink to={item.to} className="sidenav__nav-link">
          <Component item={item} />
        </NavLink>
      ) : (
        <Component item={item} />
      )}
    </>
  );
};

export default CustomMenuItem;
